<template>
  <div>
    <el-dialog
      :title="`添加${name}`"
      :visible="visible"
      top="10vh"
      width="1200px"
      append-to-body
      @close="handleCancel"
    >
      <el-row
        type="flex"
        justify="space-between"
      >
        <el-col :span="18">
          <el-tabs v-model="active_tabs">
            <el-tab-pane label="系统拓词" name="system">
              <system-word :advertiser-id="advertiserId" @confirm="onSystemWordConfirm" />
            </el-tab-pane>
            <el-tab-pane label="手动填词" name="custom">
              <el-card
                shadow="never"
                :body-style="{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }"
              >
                <el-input
                  v-model="input_value"
                  type="textarea"
                  :placeholder="`每行输入一个${name}，单个${name}不超过${wordMaxLength}个字`"
                  clearable
                  resize="none"
                  :rows="20"
                />
                <div style="margin-top: 20px">
                  <el-button
                    style="float: right"
                    type="primary"
                    @click="onCustomWordConfirm()"
                  >
                    添加{{ name }}
                    <i class="el-icon-caret-right" />
                  </el-button>
                </div>
              </el-card>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="6" class="ml-10">
          <el-card shadow="never">
            <div>
              <span>
                已添加{{ `${name}(${table_data.length}/${maxCount})` }}
              </span>
              <el-button
                type="text"
                @click="handleClear"
              >
                清空
              </el-button>
            </div>
            <el-table
              :data="table_data"
              height="500"
            >
              <el-table-column
                label="序号"
                type="index"
              />
              <el-table-column :label="name">
                <template slot-scope="scope">
                  <span>{{ scope.row }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="handleDelete(scope.row, scope.$index)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          icon="el-icon-bell"
          @click="handleCancel"
        >
          取 消
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-position"
          @click="handleCofirm"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    'system-word': () => import('../system-word/index.vue'),
  },
  props: {
    advertiserId: {
      type: [String, Number],
      required: true,
    },
    name: {
      type: String,
      default: '关键词',
    },
    keywords: {
      type: Array,
      default: () => [],
    },
    wordMaxLength: {
      type: Number,
      default: 20,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    maxCount: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      table_data: [],
      input_value: '',
      active_tabs: 'system',
    };
  },
  mounted() {
    // 复制关键词
    this.table_data = this.keywords.slice();
  },
  methods: {
    /** 取消 关闭弹窗 */
    handleCancel() {
      this.$emit('update:visible', false);
    },
    /** 确认 提交关键词 */
    handleCofirm() {
      this.handleCancel();
      this.$emit('confirm', this.table_data);
    },
    /** 自定义关键词确认 */
    onCustomWordConfirm() {
      if (!this.input_value) {
        this.$message.warning(`请输入${this.name}`);
        return;
      }
      const keywords = this.input_value.split('\n');
      const result = this.handleAddKeywords(keywords);
      result && (this.input_value = '');
    },
    /**
     * 添加关键词
     * @param {string[]} keywords 已选中的关键词
     */
    handleAddKeywords(keywords = []) {
      // 筛选出有效的关键词
      const valid_keywords = keywords.filter(
        (keyword) => keyword.trim().length > 0 && keyword.trim().length <= this.wordMaxLength,
      );
      if (valid_keywords.length === 0) {
        this.$message.warning(`请添加有效${this.name}`);
        return false;
      }
      if (valid_keywords.length !== keywords.length) {
        this.$message.warning(`剔除部分无效${this.name}`);
      }
      if ((valid_keywords.length + this.table_data.length) > this.maxCount) {
        // 删除多余的关键词
        valid_keywords.splice(this.maxCount - this.table_data.length);
        this.$message.warning(`最多添加${this.maxCount}个${this.name},已剔除多余${this.name}`);
      }

      this.table_data = this.table_data.concat(valid_keywords);
      return true;
    },
    /** 清空现有关键词 */
    handleClear() {
      this.$confirm(`是否清空所有${this.name}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.table_data = [];
      });
    },
    /**
     * 清空现有关键词
     * @param {string} keyword 关键词
     * @param {number} index 关键词索引
     */
    handleDelete(keyword, index) {
      this.$confirm(`是否删除该${this.name}:[${keyword}]`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.table_data.splice(index, 1);
      });
    },
    /**
     * 系统关键词确认
     * @param {Object[]} selection 已选中的系统关键词数据
     */
    onSystemWordConfirm(selection) {
      if (!selection.length) {
        this.$message.warning(`请选择${this.name}`);
        return;
      }
      const word_list = selection.map(({ word }) => word);
      this.handleAddKeywords(word_list);
    },
  },
};
</script>
<style scoped>
.el-card {
  height: 100%;
}
.el-textarea /deep/ .el-textarea__inner {
  height: 100%;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
